import React, { memo, useState, useEffect } from "react";
import DateRangeIcon from "@material-ui/icons/DateRange";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { capitalize } from "../../../utils";
import { selectionStore } from "../../../stores/selection.store";
import { CalendarLayout, GolEventListener } from "../../calendar/calendar";
import { CalendarLegend } from "../../calendar/calendar-legend/calendar-legend";
import { InputWithIcon } from "../../input-with-icon/input-with-icon";
import { selectionStoreChangesService } from "../../../services/selection-store-changes.service";
import { getLanguageSwitcherService } from "../../../services/language-switcher.service";
import { DayStatus } from "../../../types";
import calendarService from "../../../services/calendar-service";
import { moduleSettings } from "../../../stores/module-settings.store";

const CalendarWrapper = styled.div`
  width: 300px;
`;

const Calendar = () => {
  const { i18n } = useTranslation();
  const [selectedDate, setSelectedDate] = useState(selectionStore.date);
  const [localeForMoment, setLocaleForMoment] = useState(null);
  const isPreCatelanRestaurant = moduleSettings.isPreCatelanRestaurant;
  const shouldHideLegend =
    moduleSettings.shouldHideLegend || isPreCatelanRestaurant;

  useEffect(() => {
    setLocaleForMoment(getLanguageSwitcherService().localeForMoment());
  }, [i18n.language]);

  useEffect(() => {
    selectionStoreChangesService.registerListener(
      "selection-calendar",
      [GolEventListener.CalendarDate],
      () => {
        const status =
          calendarService.getStatus(selectionStore.date) ||
          DayStatus.unavailable;
        if (status === DayStatus.available || status === DayStatus.waiting) {
          setSelectedDate(selectionStore.date);
        } else {
          setSelectedDate(null);
          selectionStore.time = "";
          selectionStoreChangesService.dispatch(GolEventListener.Time);
        }
      }
    );

    return () => {
      selectionStoreChangesService.unregisterListener("selection-calendar");
    };
  }, []);

  return (
    <CalendarWrapper data-test="selection-date" id="selection-date">
      <InputWithIcon
        error={false}
        value={
          Number(selectedDate) > 0
            ? capitalize(
                moment(selectedDate).locale(localeForMoment).format("dddd LL")
              )
            : ""
        }
        placeholderKey={"instabook.bookings.date"}
        helperText={""}
        variant={"outlined"}
        icon={<DateRangeIcon />}
        isSummary={true}
      />
      <CalendarLayout />
      {!shouldHideLegend && <CalendarLegend />}
    </CalendarWrapper>
  );
};
export const SelectionCalendar = memo(Calendar);
